import { Debounce, getCookie, setCookie, wx_launch } from "@/assets/js/common.js";
import { BuiedPointClick_Fn, aibenClick_Fn } from "@/assets/js/BuriedPointEvent.js";
import openWxTag from "@/components/common/openWeappTag/index.vue";

export default {
  name: "userCardSearch",
  props: ["loginFlag", "babyInfo", "currentBabyInfo", "babyDays", "editFlag", "currentPath"],
  data() {
    return {
      switchBabyFlag: false,
      showeditTips: false,
      searchText: "",
      countMessage: "0",
      UserInfo: {}, // 用户信息
      nums: 0
    };
  },
  components: {
    openWxTag
  },
  computed: {
    memberState() {
      let editFlag = this.editFlag;
      let loginFlag = this.loginFlag;
      return {
        editFlag,
        loginFlag
      };
    }
  },

  watch: {
    memberState: {
      //监听loginFlag
      // 添加防抖监听数据，等数据不变之后执行对呀的方法
      handler: Debounce(function(val) {
        console.log("memberState111", val);
        if (val.loginFlag) {
          this.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
          this.getCountMessage();
          // 定制
          if (val.editFlag) {
            this.showeditTips = false;
          } else {
            if (JSON.parse(sessionStorage.getItem("editFlagTip"))) {
              this.showeditTips =
                JSON.parse(sessionStorage.getItem("editFlagTip")) || true;
            }
          }
        }
      }, 1800),
      immediate: true
    },
    currentBabyInfo(newVal) {
      if (newVal.tag_id > 1) {
        this.getMonthInfo();
      }
    },
    babyDays(newVal) {
      console.log("babyDays", this.babyDays, newVal);
    }
    // 解决跳转自动变false
    // showeditTips(val){
    //   if(this.memberState.editFlag){
    //     this.showeditTips =false
    //   }else{
    //     if (JSON.parse(sessionStorage.getItem("editFlagTip"))) {
    //       this.showeditTips = JSON.parse(sessionStorage.getItem("editFlagTip")) || true;
    //     }
    //   }
    // }
  },
  created() {
    console.log(this.switchBabyFlag, 'switchBabyFlag')
  },
  mounted() {
    console.log(this.switchBabyFlag, 'switchBabyFlag11111')
    console.log(this.babyInfo)
  },
  activated() {
    // console.log('this.memberState',this.memberState)
    // 未注册
    if (!this.memberState.loginFlag || this.memberState.editFlag) {
      this.showeditTips = false;
    } else {
      if (JSON.parse(sessionStorage.getItem("editFlagTip"))) {
        this.showeditTips =
          JSON.parse(sessionStorage.getItem("editFlagTip")) || true;
      }
    }
  },
  methods: {
    getCookie,
    setCookie,
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      return document.querySelector(".usercard-search");
    },
    closeEditTips() {
      this.switchBabyFlag = false;
      sessionStorage.setItem("editFlagTip", false);
      this.showeditTips = false;
    },
    openBabyList() {
      if(this.$route.name == 'aiBenHome'){
        aibenClick_Fn('xmh_aibenh5_home_elements_click',{
          xmh_aibenh5_elements_name: '状态切换'
        })
      } else {
        setTimeout(() => {
          BuiedPointClick_Fn("xmhh5_home_babystate_click");
        }, 300);
      }
      // 判断登陆状态，如果未登陆，则跳转到登陆页面
      if (!this.loginFlag) {
        this.toLogin();
      } else {
        this.switchBabyFlag = !this.switchBabyFlag;
      }
    },
    // 所有月龄信息
    getMonthInfo() {
      if (
        this.currentBabyInfo.birth != "" &&
        this.currentBabyInfo.birth != null
      ) {
        this.$http.get(
          "/babyCareTips/getAllInfo",
          { dayBith: this.currentBabyInfo.birth },
          res => {
            if (res.code == "200") {
              this.babyMonthList = res.data;
              var tagTime = res.data.tagTime;
              var len = res.data.babyCareTipsList.length;
              //如果是育儿中并且在三岁以上取最后一个
              if (res.data.stage == 2 && tagTime > 35) {
                this.babyMonthList.tagTime = 40;
                this.active = len - 1;
              } else {
                this.active = tagTime;
              }
              res.data.stage == 1
                ? (this.babyChangeImg = this.babyMonthList.babyCareTipsList[
                    this.active
                  ].fetusSizePic)
                : (this.babyChangeImg = this.babyMonthList.babyCareTipsList[
                    this.active
                  ].homePagePic);
              this.babyChangeText = this.babyMonthList.babyCareTipsList[
                this.active
              ].babyChange;
              this.$emit("getBabyTips", this.babyMonthList);
            }
          }
        );
      }
    },
    // 跳转管理宝宝
    glBaby() {
      sensors.track("home_changebaby_click", {
        operation_changebaby: "管理宝宝"
      });
      var that = this;
      setTimeout(function() {
        location.href =
          location.origin +
          "/member/babyManage?num=" +
          that.currentBabyInfo.num +
          "&redirect=" +
          encodeURIComponent(window.location.href);
      }, 200);
    },
    // 跳转签到
    goSigin() {
      sensors.track("home_qiandao_click");
      localStorage.setItem("signin_source", "星妈会首页");
      // setTimeout(() => {
      //   location.href = location.origin + "/member/mine/newPoint?source=xmhH5&isSignIn=true";
      // });
    },
    // 查看是否有未读消息
    getCountMessage() {
      const data = new Date();
      const month =
        data.getMonth() + 1 >= 10
          ? data.getMonth() + 1
          : `0${data.getMonth() + 1}`;
      const day = data.getDate() >= 10 ? data.getDate() : `0${data.getDate()}`;
      const hours =
        data.getHours() >= 10 ? data.getHours() : `0${data.getHours()}`;
      const minutes =
        data.getMinutes() >= 10 ? data.getMinutes() : `0${data.getMinutes()}`;
      const seconds =
        data.getSeconds() >= 10 ? data.getSeconds() : `0${data.getSeconds()}`;
      const timestamp = `${data.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      console.log("this.UserInfo.crm_id", this.UserInfo.crm_id);
      this.$http.get(
        this.$http.harvardBaseURL +
          "/like/countMessage/ZBvOm0ocQSUykUX5?time=" +
          timestamp,
        { crmId: this.UserInfo.crm_id },
        res => {
          if (res.code == "200") {
            this.countMessage = res.data;
          }
        }
      );
    },
    // 跳转登陆页面
    toLogin() {
      sensors.track("home_logiguide_click");
      this.$emit("goLogin");
    },
    // 点击新提醒消息按钮
    toNewMseeage: function() {
      if(this.$route.name == 'aiBenHome') {
       aibenClick_Fn('xmh_aibenh5_home_elements_click',{
        xmh_aibenh5_elements_name: '消息'
       })
      } else {
       sensors.track("home_message_click");
      }
      this.$router.push("/newMessage");
    },
    toSearch() {
      sensors.track("home_search_click");
      sessionStorage.setItem("searchVal", "home");
      this.$router.push({
        path: "/search",
        query: {
          searchIndex: "home"
        }
      });
    },
    // 跳转AI对话页
    goToAiTalk() {
      this.$emit("goToAiTalk")
    },
    // 跳转爱本
    // type 0代表首页，1代表爱本
    gotoPage(type) {
      this.closeBaby();
      this.$nextTick(()=>{
        type === 1 && this.$router.replace({
          path: "/aiben",
          query: {
            source: 'home'
          }
        }) || location.replace('./home?source=edit')
      })
    },
    // 添加宝宝
    addBaby() {
      sensors.track("home_changebaby_click", {
        operation_changebaby: "添加宝宝"
      });
      var that = this;
      localStorage.setItem("editModule", "添加宝宝");
      setTimeout(function() {
        // that.$router.push({ path: '/loginEdit?redirect=' + window.location.href + '&multipleBirth=2' })
        location.href =
          location.origin +
          "/member/loginEdit?redirect=" +
          window.location.href +
          "&multipleBirth=1" +
          "&title=" +
          that.$route.meta.title;
      }, 200);
    },
    // 切换宝宝
    switchBabyInfo(item) {
      sensors.track("home_changebaby_click", {
        operation_changebaby: "切换宝宝"
      });
      if (this.nums !== item.num) {
        var state =
          item.tag_id > 2
            ? item.sex == "F"
              ? "小公主"
              : "小王子"
            : item.tag_id == "1"
            ? "备孕"
            : "怀孕";
        sensors.track("home_babybianhua_click", {
          baby_state: state
        });
      }
      localStorage.setItem("babyNums", item.num);
      localStorage.setItem("babyBir", item.birth);
      this.setCookie("babyNum", item.num, 30);
      console.log("宝宝胎次", item.num);
      this.nums = item.num;
      // var babyNum = localStorage.getItem("babyNum");
      // var preweek =
      //   item.num == "1" ? this.babyDays.firsttime : this.babyDays.secondtime;
      this.closeBaby();
      this.$emit("getSwitchBaby");
    },
    // 关闭切换宝宝弹窗
    closeBaby() {
      sensors.track("home_changebaby_click", {
        operation_changebaby: "无操作"
      });
      this.switchBabyFlag = false;
    }
  }
};
